import { listDocumentsEpic } from './state/list-documents.epic';
import { reloadEpic } from './state/reload.epic';

export const blDialogEpics = [reloadEpic, listDocumentsEpic];
